<template>
  <section class="heroHeader" ref="heroSection">
    <FlarePicture
      v-if="image || page.image"
      class="heroHeader__Image"
      :src="{
        1920: { src: image || page.image, width: 1920, height: 960, ...commonImageAttrs },
        1440: { src: image || page.image, width: 1440, height: 720, ...commonImageAttrs },
        1024: { src: image || page.image, width: 1024, height: 512, ...commonImageAttrs },
        768: { src: image || page.image_mobile || page.image, width: 768, height: 1040, ...commonImageAttrs },
      }"
      :alt="image?.alt || page.image?.alt"
    />

    <div v-if="titleVisible" class="container">
      <div class="heroHeader__TitleContainer">
        <div v-if="page.lead" class="heroHeader__SuperTitle" v-html="page.lead" />
        <h1 class="heroHeader__Title" v-text="page.title" />
      </div>
    </div>

    <div v-if="$slots.default" class="heroHeader__SlotContainer">
      <slot />
    </div>
  </section>
</template>

<script setup>
  const props = defineProps({
    fixedHeader: {
      type: Boolean,
      default: false,
    },
    titleVisible: {
      type: Boolean,
      default: true,
    },
    image: {},
    notTransparent: {
      type: Boolean,
      default: false,
    }
  });

  const { page } = usePage();
  const heroSection = ref(null);
  const commonImageAttrs = {
    size: 'both',
    crop: 'fill',
    requestLarger: false
  }

  onMounted(() => {
    if (props.notTransparent) return;
    document.documentElement.classList.add('transparentHeader');
    window.addEventListener('scroll', detectHeaderPosition);
  });

  onBeforeUnmount(() => {
    if (props.notTransparent) return;
    document.documentElement.classList.remove('transparentHeader');
    window.removeEventListener('scroll', detectHeaderPosition);
  });

  function detectHeaderPosition() {
    const { top } = heroSection.value.getBoundingClientRect();
    document.documentElement.classList[(top < 0) ? 'remove' : 'add']('transparentHeader');
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_heroHeader.scss');
</style>